<template>
  <div class="partner-page">
    <div class="partner-container">
      <h2 class="page-title">合作商户</h2>
      
      <div class="partner-list">
        <div v-for="(item, index) in partnerList" :key="index" class="partner-item">
          <a :href="item.url" target="_blank" class="partner-link">
            <div class="img-box">
               <img :src="item.image" :alt="item.title" />
            </div>
            <div class="partner-name">{{ item.title }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/store/axios'
import URL from '@/_url_'

export default {
  name: 'Partner',
  data() {
    return {
      partnerList: []
    }
  },
  created() {
    this.getPartnerList();
  },
  methods: {
    getPartnerList() {
      let lang = localStorage.lang || 'cn';
      axios.get(`/index/partner/partnerlist?lang=${lang}`)
        .then(res => {
          if (res.data.code == 1) {
            let list = res.data.partnerlist;
            // Process image URLs
            list.forEach(item => {
              if (item.image && item.image.indexOf('http') < 0) {
                item.image = URL.imgUrl + item.image;
              }
            });
            this.partnerList = list;
          }
        })
        .catch(err => {
          console.error('Failed to fetch partner list:', err);
        });
    }
  }
}
</script>

<style scoped>
.partner-page {
  background-color: #f9f9f9;
  padding: 50px 0;
  min-height: calc(100vh - 300px); /* Ensure footer stays at bottom */
}

.partner-container {
  width: 1200px;
  margin: 0 auto;
}

.page-title {
  text-align: center;
  font-size: 36px;
  color: #333;
  margin-bottom: 50px;
  font-weight: 400;
}

.partner-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.partner-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.partner-item {
  width: 20%; /* 5 columns */
  padding: 0 15px;
  margin-bottom: 40px;
  box-sizing: border-box;
  text-align: center;
}

.img-box {
  background: #fff;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: all 0.3s;
  border-radius: 4px;
}

.img-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.img-box img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}

.partner-name {
  font-size: 16px;
  color: #333;
}
</style>
